import { useEffect, useState } from "react";
import { useToast } from "../../../../Hooks/ToasContext";
import { MarkAsReadNotificationsUseCase } from "../../../../Usecase/Notifications/mark-as-read-notifications-usecase";

interface IUseStockDiscrepancyProps {
    notificationId: string;
    markAsReadNotificationUseCase: MarkAsReadNotificationsUseCase
}
export function useStockDiscrepancy({ notificationId, markAsReadNotificationUseCase }: IUseStockDiscrepancyProps) {
    const [loading, setLoading] = useState(false)
    const { showToast } = useToast()

    const handleMarkAsReadNotification = async () => {
        try {
            const response = await markAsReadNotificationUseCase.handle(notificationId)

            if(response.isFailure) {
                showToast(String(response?.error?.error), 'error')
                return
            }

            
        } catch (error) {
            console.log("error markAsReadNotification function: ", error)
        }
    }



    useEffect(() => {
        handleMarkAsReadNotification()
    }, [])

    return {
        loading,
        handleMarkAsReadNotification
    }


}